export const DEFAULT_IMPORT_DATABASE_FIELD_COUNT = 7;

export const databasesToContentId = {
  emptyDatabase: '000001',
  databaseWithViewsOverflow: '000003',
  databaseWithSampleCsvStructure: '000004',
  databaseWithSampleCsvStructureWithUgc: '000005',
  databaseWithContent: '000006',
  databaseWithUserField: '000007',
  databaseWithBasicFields: '000008',
  databaseWithUserAndLinkField: '000009',
  databaseWithSelfReferenceEntryLinkField: '000010',
  databaseWithFilters: '000011',
  databaseWithJiraIssueFieldsAndComments: '000013',
  databaseWithAttachments: '000014',
  databaseWithSampleCsvManyRows: '000015',
  databaseWithRichContent: '000016',
  databaseWithRichContentOverflow: '000017',
};

export type DatabaseKey = keyof typeof databasesToContentId;
